import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import {complianceArtifactsUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {ComplianceArtifact} from "~/pages/supplier-360/types/Supplier360Types";

/** The evidence files of one compliance record (`GET supplier_360/compliance_artifact/`, §2.9), unpaginated. */
export function useComplianceArtifactsQuery(requirementId: number | undefined) {
    const url = complianceArtifactsUrl(requirementId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<ComplianceArtifact[]>(url)).data,
        enabled: Boolean(requirementId),
    });
}
